<!-- eslint-disable vue/no-mutating-props -->
<!-- 优惠券、卡券、充值套餐与营销活动的弹窗模块。表单状态由父页面集中管理。 -->
<template>
  <el-dialog :model-value="couponEditorVisible" :title="isEditingCoupon ? '编辑优惠券' : '新建优惠券'" width="760px" @update:model-value="emit('update:couponEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="优惠券名称" hint="用户领取和使用时看到的名称。" required>
            <el-input v-model.trim="couponForm.name" placeholder="如 新人首单券" />
          </GuidedField>
          <GuidedField label="优惠券类型" hint="满减券按金额减免，折扣券按折扣比例优惠。" required>
            <el-select v-model="couponForm.type">
              <el-option label="满减券" value="FULL_REDUCTION" />
              <el-option label="折扣券" value="DISCOUNT" />
            </el-select>
          </GuidedField>
          <GuidedField v-if="isFullReductionCoupon" label="优惠面额" hint="满减券填写减免金额，单位为元。">
            <el-input v-model.number="couponForm.amount" type="number" step="0.01" placeholder="如 8，表示 ¥8" />
          </GuidedField>
          <GuidedField v-if="isDiscountCoupon" label="折扣系数" hint="折扣券填写 0-1 之间的系数，如 0.88 表示 8.8 折。">
            <el-input v-model="couponForm.discountRate" type="number" placeholder="如 0.88" />
          </GuidedField>
          <GuidedField label="使用门槛" hint="订单金额达到该值才可使用，单位为元；0 表示无门槛。">
            <el-input v-model.number="couponForm.threshold" type="number" step="0.01" placeholder="如 20，表示满 ¥20" />
          </GuidedField>
          <GuidedField label="优惠券库存" hint="最多可被领取或发放的总数量。">
            <el-input v-model.number="couponForm.totalCount" type="number" placeholder="如 1000" />
          </GuidedField>
          <GuidedField label="每人限领" hint="同一用户最多可领取的数量。">
            <el-input v-model.number="couponForm.perUserLimit" type="number" placeholder="如 1" />
          </GuidedField>
          <GuidedField label="适用门店" hint="店长新建时必须选择授权门店。" wide>
            <el-select v-model="couponStoreIds" multiple filterable placeholder="请选择适用门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="有效期类型" hint="选择按固定日期失效，还是领取后按天数失效。">
            <el-select v-model="couponForm.validType">
              <el-option label="固定时间段" value="DATE_RANGE" />
              <el-option label="领券后生效天数" value="DAYS" />
            </el-select>
          </GuidedField>
          <GuidedField label="开始时间" hint="固定时间段的开始时间，格式 YYYY-MM-DD HH:mm:ss。">
            <AdminDateTimePicker v-model="couponForm.validFrom" placeholder="请选择开始时间" />
          </GuidedField>
          <GuidedField label="结束时间" hint="固定时间段的结束时间，格式 YYYY-MM-DD HH:mm:ss。">
            <AdminDateTimePicker v-model="couponForm.validTo" placeholder="请选择结束时间" />
          </GuidedField>
          <GuidedField label="领取后有效天数" hint="仅在选择“领取后生效天数”时使用。">
            <el-input v-model.number="couponForm.validDays" type="number" placeholder="如 30" />
          </GuidedField>
          <GuidedField label="优惠券状态" hint="停用后用户不能继续领取或使用。">
            <el-select v-model="couponForm.status">
              <el-option label="启用" value="ENABLED" />
              <el-option label="停用" value="DISABLED" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:couponEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="couponSubmitting" :disabled="!couponForm.name" @click="emit('submitCoupon')">
        {{ isEditingCoupon ? '保存修改' : '创建优惠券' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="couponIssueVisible" title="发放优惠券" width="560px" @update:model-value="emit('update:couponIssueVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="发放范围" hint="选择全部用户，或只发给指定用户。">
            <el-select v-model="couponIssueForm.targetType">
              <el-option label="全部用户" value="ALL" />
              <el-option label="指定用户" value="USER" />
            </el-select>
          </GuidedField>
          <GuidedField label="每人发放数量" hint="每个用户本次获得的优惠券张数。">
            <el-input v-model.number="couponIssueForm.count" type="number" placeholder="如 1" />
          </GuidedField>
          <GuidedField v-if="couponIssueForm.targetType === 'USER'" label="指定用户" hint="可搜索并多选用户；不需要手填用户 ID。" wide required>
            <el-select v-model="couponIssueTargetUserIds" multiple filterable collapse-tags collapse-tags-tooltip placeholder="请选择用户">
              <el-option v-for="user in userOptions" :key="user.id" :label="user.nickname || user.phone || user.id" :value="user.id">
                <span>{{ user.nickname || '未命名用户' }}</span>
                <small class="option-code">{{ user.phone || user.id }}</small>
              </el-option>
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:couponIssueVisible', false)">取消</el-button>
      <el-button type="primary" :loading="couponSubmitting" :disabled="!couponIssueForm.couponId" @click="emit('submitCouponIssue')">确认发放</el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="bannerEditorVisible" :title="isEditingBanner ? '编辑首页 Banner' : '新增首页 Banner'" width="760px" @update:model-value="emit('update:bannerEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="Banner 标题" hint="小程序首页轮播图对应的运营标题。" required>
            <el-input v-model.trim="bannerForm.title" placeholder="如 新品上市" />
          </GuidedField>
          <GuidedField label="Banner 图片" hint="从本地选择图片，前端会直接展示。" wide required>
            <LocalImagePicker v-model="bannerForm.imageUrl" button-text="选择 Banner 图片" />
          </GuidedField>
          <GuidedField label="跳转类型" hint="与小程序端约定的 linkType 保持一致。">
            <el-select v-model="bannerForm.linkType" clearable placeholder="不跳转">
              <el-option label="商品" value="PRODUCT" />
              <el-option label="活动" value="ACTIVITY" />
              <el-option label="页面路径" value="PAGE" />
            </el-select>
          </GuidedField>
          <GuidedField label="跳转值" hint="商品 ID、活动编码或小程序页面路径。">
            <el-input v-model.trim="bannerForm.linkValue" placeholder="如 1 或 /pages/member/index" />
          </GuidedField>
          <GuidedField label="适用门店" hint="不选择表示平台全局 Banner，仅平台管理员可保存。">
            <el-select v-model="bannerStoreId" clearable filterable placeholder="平台全局">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="展示排序" hint="数值越小越靠前。">
            <el-input v-model.number="bannerForm.sort" type="number" placeholder="如 1" />
          </GuidedField>
          <GuidedField label="开始时间" hint="为空表示不限制开始时间。">
            <AdminDateTimePicker v-model="bannerForm.startAt" placeholder="请选择开始时间" />
          </GuidedField>
          <GuidedField label="结束时间" hint="为空表示不限制结束时间。">
            <AdminDateTimePicker v-model="bannerForm.endAt" placeholder="请选择结束时间" />
          </GuidedField>
          <GuidedField label="Banner 状态" hint="停用后小程序首页不会展示。">
            <el-select v-model="bannerForm.enabled">
              <el-option label="启用" :value="true" />
              <el-option label="停用" :value="false" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:bannerEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="bannerSubmitting" :disabled="!bannerForm.title || !bannerForm.imageUrl" @click="emit('submitBanner')">
        {{ isEditingBanner ? '保存修改' : '创建 Banner' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="rechargePackageEditorVisible" :title="isEditingRechargePackage ? '编辑充值套餐' : '新增充值套餐'" width="640px" @update:model-value="emit('update:rechargePackageEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="套餐名称" hint="用户选择充值套餐时看到的名称。" required>
            <el-input v-model.trim="rechargePackageForm.name" placeholder="如 充 100 送 10" />
          </GuidedField>
          <GuidedField label="充值金额" hint="用户实际支付金额，单位为元。">
            <el-input v-model.number="rechargePackageForm.amount" type="number" step="0.01" placeholder="如 100，表示 ¥100" />
          </GuidedField>
          <GuidedField label="赠送余额" hint="充值后额外到账的余额，单位为元。">
            <el-input v-model.number="rechargePackageForm.giftBalance" type="number" step="0.01" placeholder="如 10，表示 ¥10" />
          </GuidedField>
          <GuidedField label="赠送优惠券模板" hint="可选择多张优惠券模板，选填。" wide>
            <el-select
              v-model="rechargePackageGiftCouponTemplateIds"
              multiple
              filterable
              collapse-tags
              collapse-tags-tooltip
              placeholder="请选择赠送优惠券"
            >
              <el-option v-for="coupon in couponOptions" :key="coupon.id" :label="coupon.name" :value="coupon.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="展示排序" hint="数值越小越靠前。">
            <el-input v-model.number="rechargePackageForm.sort" type="number" placeholder="如 10" />
          </GuidedField>
          <GuidedField label="套餐状态" hint="下架后用户端不能继续购买。">
            <el-select v-model="rechargePackageForm.enabled">
              <el-option label="上架" :value="true" />
              <el-option label="下架" :value="false" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:rechargePackageEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="rechargeSubmitting" :disabled="!rechargePackageForm.name" @click="emit('submitRechargePackage')">
        {{ isEditingRechargePackage ? '保存修改' : '创建套餐' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="cardTemplateEditorVisible" :title="isEditingCardTemplate ? '编辑卡券模板' : '新建卡券模板'" width="720px" @update:model-value="emit('update:cardTemplateEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="卡券名称" hint="用户看到的卡券名称。" required>
            <el-input v-model.trim="cardTemplateForm.name" placeholder="如 月卡畅饮券" />
          </GuidedField>
          <GuidedField label="卡券类型" hint="次卡按次数核销，储值卡按余额使用。" required>
            <el-select v-model="cardTemplateForm.category">
              <el-option label="次卡" value="COUNT_CARD" />
              <el-option label="储值卡" value="BALANCE_CARD" />
            </el-select>
          </GuidedField>
          <GuidedField label="售价" hint="用户购买卡券的价格，单位为元。">
            <el-input v-model.number="cardTemplateForm.salePrice" type="number" step="0.01" placeholder="单位：元" />
          </GuidedField>
          <GuidedField label="面值" hint="储值卡到账金额，单位为元；次卡通常不使用。">
            <el-input v-model.number="cardTemplateForm.faceValue" type="number" step="0.01" placeholder="单位：元" />
          </GuidedField>
          <GuidedField label="可用次数" hint="次卡可核销的总次数。">
            <el-input v-model.number="cardTemplateForm.countValue" type="number" placeholder="如 10 次" />
          </GuidedField>
          <GuidedField label="有效天数" hint="从购买或领取后开始计算的有效天数。">
            <el-input v-model.number="cardTemplateForm.validDays" type="number" placeholder="如 30" />
          </GuidedField>
          <GuidedField label="卡券库存" hint="最多可售或发放的卡券数量。">
            <el-input v-model.number="cardTemplateForm.totalCount" type="number" placeholder="如 1000" />
          </GuidedField>
          <GuidedField label="每人限领" hint="同一用户最多可拥有的数量。">
            <el-input v-model.number="cardTemplateForm.perUserLimit" type="number" placeholder="如 1" />
          </GuidedField>
          <GuidedField label="适用门店" hint="店长新建时必须选择授权门店；平台角色可留空表示全部门店。" wide>
            <el-select v-model="cardTemplateStoreIds" multiple filterable placeholder="请选择适用门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id">
                <span>{{ store.name }}</span>
                <small class="option-code">{{ store.code || store.id }}</small>
              </el-option>
            </el-select>
          </GuidedField>
          <GuidedField label="权益描述" hint="说明卡券能兑换什么，以及使用限制。" wide>
            <el-input v-model.trim="cardTemplateForm.benefit" placeholder="如 可兑换任意中杯饮品 1 杯" />
          </GuidedField>
          <GuidedField label="卡券状态" hint="停用后用户端不能购买或使用。">
            <el-select v-model="cardTemplateForm.status">
              <el-option label="启用" value="ENABLED" />
              <el-option label="停用" value="DISABLED" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:cardTemplateEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="cardSubmitting" :disabled="!cardTemplateForm.name" @click="emit('submitCardTemplate')">
        {{ isEditingCardTemplate ? '保存修改' : '创建卡券' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="groupBuyEditorVisible" :title="isEditingGroupBuy ? '编辑拼团活动' : '创建拼团活动'" width="760px" @update:model-value="emit('update:groupBuyEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="活动名称" hint="用户看到的拼团活动名称。" required>
            <el-input v-model.trim="groupBuyForm.name" placeholder="如 夏日咖啡拼团" />
          </GuidedField>
          <GuidedField label="活动商品" hint="选择参与拼团的商品。" required>
            <el-select v-model="groupBuyForm.productId" filterable placeholder="请选择商品">
              <el-option v-for="product in productOptions" :key="product.id" :label="product.name" :value="product.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="适用门店" hint="店长新建时必须选择授权门店；平台角色可留空表示全部门店。">
            <el-select v-model="groupBuyStoreIds" multiple filterable placeholder="全部门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="拼团价" hint="成团后每位用户支付的价格，单位为元。">
            <el-input v-model.number="groupBuyForm.groupPrice" type="number" step="0.01" placeholder="单位：元" />
          </GuidedField>
          <GuidedField label="成团人数" hint="达到该人数后拼团成功。">
            <el-input v-model.number="groupBuyForm.teamSize" type="number" placeholder="如 2" />
          </GuidedField>
          <GuidedField label="拼团有效时长" hint="从开团开始计算的小时数。">
            <el-input v-model.number="groupBuyForm.durationHours" type="number" placeholder="如 24 小时" />
          </GuidedField>
          <GuidedField label="开始时间" hint="活动开始时间，格式 YYYY-MM-DD HH:mm:ss。">
            <AdminDateTimePicker v-model="groupBuyForm.startAt" placeholder="请选择开始时间" />
          </GuidedField>
          <GuidedField label="结束时间" hint="活动结束时间，格式 YYYY-MM-DD HH:mm:ss。">
            <AdminDateTimePicker v-model="groupBuyForm.endAt" placeholder="请选择结束时间" />
          </GuidedField>
          <GuidedField label="活动状态" hint="草稿不会对用户展示，启用后才会开始运营。">
            <el-select v-model="groupBuyForm.status">
              <el-option label="草稿" value="DRAFT" />
              <el-option label="启用" value="ENABLED" />
              <el-option label="停用" value="DISABLED" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:groupBuyEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="groupBuySubmitting" :disabled="!groupBuyForm.name" @click="emit('submitGroupBuy')">
        {{ isEditingGroupBuy ? '保存修改' : '创建活动' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="bargainEditorVisible" :title="isEditingBargain ? '编辑砍价活动' : '创建砍价活动'" width="720px" @update:model-value="emit('update:bargainEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="活动名称" hint="用户看到的砍价活动名称。" required>
            <el-input v-model.trim="bargainForm.name" placeholder="如 夏日砍价活动" />
          </GuidedField>
          <GuidedField label="活动商品" hint="选择参与砍价的商品。" required>
            <el-select v-model="bargainForm.productId" filterable placeholder="请选择商品">
              <el-option v-for="product in productOptions" :key="product.id" :label="product.name" :value="product.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="适用门店" hint="店长新建时必须选择授权门店；平台角色可留空表示全部门店。">
            <el-select v-model="bargainStoreIds" multiple filterable placeholder="全部门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="初始价" hint="砍价开始时的商品价格，单位为元。">
            <el-input v-model.number="bargainForm.initPrice" type="number" step="0.01" placeholder="单位：元" />
          </GuidedField>
          <GuidedField label="最低价" hint="砍价成功后允许达到的最低价格，单位为元。">
            <el-input v-model.number="bargainForm.floorPrice" type="number" step="0.01" placeholder="单位：元" />
          </GuidedField>
          <GuidedField label="助力次数" hint="每个用户最多可邀请好友助力的次数。">
            <el-input v-model.number="bargainForm.helpTimes" type="number" placeholder="如 5" />
          </GuidedField>
          <GuidedField label="活动状态" hint="草稿不会展示给用户。">
            <el-select v-model="bargainForm.status">
              <el-option label="草稿" value="DRAFT" />
              <el-option label="启用" value="ENABLED" />
              <el-option label="停用" value="DISABLED" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:bargainEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="bargainSubmitting" :disabled="!bargainForm.name" @click="emit('submitBargain')">
        {{ isEditingBargain ? '保存修改' : '创建活动' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="inviteEditorVisible" :title="isEditingInvite ? '编辑邀请奖励' : '新增邀请奖励'" width="720px" @update:model-value="emit('update:inviteEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="什么时候发奖励" hint="当前小程序会在新用户完成注册并绑定邀请关系后发放奖励。" required>
            <el-select v-model="inviteForm.scene" placeholder="请选择发放时机">
              <el-option label="新用户注册后" value="REGISTER" />
            </el-select>
          </GuidedField>
          <GuidedField label="邀请人获得的优惠券" hint="好友完成邀请条件后，从已添加的优惠券中选择一张发给邀请人。" required>
            <el-select v-model="inviteForm.inviterCouponTemplateId" filterable clearable placeholder="请选择优惠券">
              <el-option v-for="coupon in couponOptions" :key="coupon.id" :label="coupon.name" :value="coupon.id">
                <span>{{ coupon.name }}</span>
              </el-option>
            </el-select>
          </GuidedField>
          <GuidedField label="好友获得的优惠券" hint="好友完成邀请条件后，从已添加的优惠券中选择一张发给新用户。" required>
            <el-select v-model="inviteForm.inviteeCouponTemplateId" filterable clearable placeholder="请选择优惠券">
              <el-option v-for="coupon in couponOptions" :key="coupon.id" :label="coupon.name" :value="coupon.id">
                <span>{{ coupon.name }}</span>
              </el-option>
            </el-select>
          </GuidedField>
          <GuidedField label="每人最多奖励次数" hint="同一用户邀请好友时，最多可以拿到几次奖励。">
            <el-input v-model.number="inviteForm.maxTimes" type="number" placeholder="如 10" />
          </GuidedField>
          <GuidedField label="是否发放奖励" hint="关闭后，新邀请不会再发放奖励。">
            <el-select v-model="inviteForm.enabled">
              <el-option label="启用" :value="true" />
              <el-option label="停用" :value="false" />
            </el-select>
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:inviteEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="inviteSubmitting" @click="emit('submitInvite')">
        {{ isEditingInvite ? '保存修改' : '创建配置' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="flashSaleEditorVisible" :title="isEditingFlashSale ? '编辑秒杀活动' : '创建秒杀活动'" width="840px" @update:model-value="emit('update:flashSaleEditorVisible', $event)">
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions">
          <GuidedField label="活动名称" hint="用户看到的限时秒杀活动名称。" required>
            <el-input v-model.trim="flashSaleForm.name" placeholder="如 周末咖啡秒杀" />
          </GuidedField>
          <GuidedField label="适用门店" hint="店长新建时必须选择授权门店；平台角色可留空表示全部门店。">
            <el-select v-model="flashSaleStoreIds" multiple filterable placeholder="全部门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="开始时间" hint="活动开始时间，格式 YYYY-MM-DD HH:mm:ss。">
            <AdminDateTimePicker v-model="flashSaleForm.startAt" placeholder="请选择开始时间" />
          </GuidedField>
          <GuidedField label="结束时间" hint="活动结束时间，格式 YYYY-MM-DD HH:mm:ss。">
            <AdminDateTimePicker v-model="flashSaleForm.endAt" placeholder="请选择结束时间" />
          </GuidedField>
          <GuidedField label="活动状态" hint="草稿不会展示，启用后才会参与前台活动。">
            <el-select v-model="flashSaleForm.status">
              <el-option label="草稿" value="DRAFT" />
              <el-option label="启用" value="ENABLED" />
              <el-option label="停用" value="DISABLED" />
            </el-select>
          </GuidedField>
        </div>
      </article>
      <article class="detail-card">
        <h3>秒杀商品</h3>
        <div class="detail-actions">
          <GuidedField label="秒杀商品" hint="选择参与秒杀的商品。" required>
            <el-select v-model="flashSaleItemForm.productId" filterable placeholder="请选择商品">
              <el-option v-for="product in productOptions" :key="product.id" :label="product.name" :value="product.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="商品名称" hint="仅用于列表展示，选填。">
            <el-input v-model.trim="flashSaleItemForm.productName" placeholder="如 冰美式" />
          </GuidedField>
          <GuidedField label="SKU ID" hint="商品有多个规格时填写对应规格 ID。">
            <el-input v-model.trim="flashSaleItemForm.skuId" placeholder="如 sku_001" />
          </GuidedField>
          <GuidedField label="秒杀价" hint="活动期间用户实际支付价格，单位为元。">
            <el-input v-model.number="flashSaleItemForm.salePrice" type="number" step="0.01" placeholder="单位：元" />
          </GuidedField>
          <GuidedField label="限购数量" hint="每位用户最多购买的数量。">
            <el-input v-model.number="flashSaleItemForm.limitQuantity" type="number" placeholder="如 1" />
          </GuidedField>
          <GuidedField label="活动库存" hint="本次秒杀可售库存，不等同于商品总库存。">
            <el-input v-model.number="flashSaleItemForm.stock" type="number" placeholder="如 100" />
          </GuidedField>
          <el-button type="primary" @click="emit('appendFlashSaleItem')">添加商品</el-button>
        </div>
        <div class="detail-items">
          <div v-for="(item, index) in flashSaleForm.items" :key="`${item.productId}-${index}`" class="detail-item">
            <div class="detail-item__meta">
              <strong>{{ item.productName || item.productId }}</strong>
              <small>SKU {{ item.skuId || '--' }} / 限购 {{ item.limitQuantity ?? 1 }} / 库存 {{ item.stock ?? 0 }}</small>
            </div>
            <div class="detail-item__right">
              <strong>{{ formatAmount(item.salePrice ?? 0) }}</strong>
              <button @click="emit('removeFlashSaleItem', index)">删除</button>
            </div>
          </div>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:flashSaleEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="flashSubmitting" :disabled="!flashSaleForm.name" @click="emit('submitFlashSale')">
        {{ isEditingFlashSale ? '保存修改' : '创建活动' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AdminDateTimePicker from '@/components/AdminDateTimePicker.vue'
import GuidedField from '@/components/GuidedField.vue'
import LocalImagePicker from '@/components/LocalImagePicker.vue'
import type { AdminProduct } from '@/api/product'
import type { AdminStore } from '@/api/store'
import type { AdminConsumerUser } from '@/api/user'
import type {
  AdminCoupon,
  BannerSavePayload,
  BargainSavePayload,
  CardTemplateSavePayload,
  CouponIssuePayload,
  CouponSavePayload,
  FlashSaleItem,
  FlashSaleSavePayload,
  GroupBuySavePayload,
  InviteConfigSavePayload,
  RechargePackageSavePayload,
} from '@/api/marketing'

const props = defineProps<{
  couponEditorVisible: boolean
  couponIssueVisible: boolean
  bannerEditorVisible: boolean
  rechargePackageEditorVisible: boolean
  cardTemplateEditorVisible: boolean
  groupBuyEditorVisible: boolean
  bargainEditorVisible: boolean
  inviteEditorVisible: boolean
  flashSaleEditorVisible: boolean
  couponSubmitting: boolean
  bannerSubmitting: boolean
  rechargeSubmitting: boolean
  cardSubmitting: boolean
  groupBuySubmitting: boolean
  bargainSubmitting: boolean
  inviteSubmitting: boolean
  flashSubmitting: boolean
  couponForm: CouponSavePayload
  couponIssueForm: CouponIssuePayload
  bannerForm: BannerSavePayload
  rechargePackageForm: RechargePackageSavePayload
  isEditingRechargePackage: boolean
  cardTemplateForm: CardTemplateSavePayload
  groupBuyForm: GroupBuySavePayload
  bargainForm: BargainSavePayload
  inviteForm: InviteConfigSavePayload
  flashSaleForm: FlashSaleSavePayload
  flashSaleItemForm: FlashSaleItem
  couponStoreIds: string[]
  bannerStoreId: string
  cardTemplateStoreIds: string[]
  groupBuyStoreIds: string[]
  bargainStoreIds: string[]
  flashSaleStoreIds: string[]
  couponIssueTargetUserIds: string[]
  rechargePackageGiftCouponTemplateIds: string[]
  storeOptions: AdminStore[]
  productOptions: AdminProduct[]
  userOptions: AdminConsumerUser[]
  couponOptions: AdminCoupon[]
  formatAmount: (amount: number) => string
}>()

const emit = defineEmits<{
  'update:couponEditorVisible': [value: boolean]
  'update:couponIssueVisible': [value: boolean]
  'update:bannerEditorVisible': [value: boolean]
  'update:rechargePackageEditorVisible': [value: boolean]
  'update:cardTemplateEditorVisible': [value: boolean]
  'update:groupBuyEditorVisible': [value: boolean]
  'update:bargainEditorVisible': [value: boolean]
  'update:inviteEditorVisible': [value: boolean]
  'update:flashSaleEditorVisible': [value: boolean]
  'update:couponStoreIds': [value: string[]]
  'update:bannerStoreId': [value: string]
  'update:cardTemplateStoreIds': [value: string[]]
  'update:groupBuyStoreIds': [value: string[]]
  'update:bargainStoreIds': [value: string[]]
  'update:flashSaleStoreIds': [value: string[]]
  'update:couponIssueTargetUserIds': [value: string[]]
  'update:rechargePackageGiftCouponTemplateIds': [value: string[]]
  submitCoupon: []
  submitCouponIssue: []
  submitBanner: []
  submitRechargePackage: []
  submitCardTemplate: []
  submitGroupBuy: []
  submitBargain: []
  submitInvite: []
  submitFlashSale: []
  appendFlashSaleItem: []
  removeFlashSaleItem: [index: number]
}>()

const isEditingCoupon = computed(() => Boolean(props.couponForm.id))
const isDiscountCoupon = computed(() => props.couponForm.type === 'DISCOUNT')
const isFullReductionCoupon = computed(() => props.couponForm.type !== 'DISCOUNT')
const isEditingBanner = computed(() => Boolean(props.bannerForm.id))
const isEditingRechargePackage = computed(() => props.isEditingRechargePackage)
const isEditingCardTemplate = computed(() => Boolean(props.cardTemplateForm.id))
const isEditingGroupBuy = computed(() => Boolean(props.groupBuyForm.id))
const isEditingBargain = computed(() => Boolean(props.bargainForm.id))
const isEditingInvite = computed(() => Boolean(props.inviteForm.id))
const isEditingFlashSale = computed(() => Boolean(props.flashSaleForm.id))
const couponStoreIds = computed({
  get: () => props.couponStoreIds,
  set: (value: string[]) => emit('update:couponStoreIds', value),
})
const bannerStoreId = computed({
  get: () => props.bannerStoreId,
  set: (value: string) => emit('update:bannerStoreId', value),
})
const cardTemplateStoreIds = computed({
  get: () => props.cardTemplateStoreIds,
  set: (value: string[]) => emit('update:cardTemplateStoreIds', value),
})
const groupBuyStoreIds = computed({
  get: () => props.groupBuyStoreIds,
  set: (value: string[]) => emit('update:groupBuyStoreIds', value),
})
const bargainStoreIds = computed({
  get: () => props.bargainStoreIds,
  set: (value: string[]) => emit('update:bargainStoreIds', value),
})
const flashSaleStoreIds = computed({
  get: () => props.flashSaleStoreIds,
  set: (value: string[]) => emit('update:flashSaleStoreIds', value),
})
const couponIssueTargetUserIds = computed({
  get: () => props.couponIssueTargetUserIds,
  set: (value: string[]) => emit('update:couponIssueTargetUserIds', value),
})
const rechargePackageGiftCouponTemplateIds = computed({
  get: () => props.rechargePackageGiftCouponTemplateIds,
  set: (value: string[]) => emit('update:rechargePackageGiftCouponTemplateIds', value),
})
</script>

<style scoped lang="scss">
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.detail-grid--single { grid-template-columns: 1fr; }
.detail-card { padding: 16px; border: 1px solid var(--jf-color-border); border-radius: 12px; background: #fff; }
.detail-card h3 { margin: 0 0 14px; font-size: 16px; }
.detail-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.detail-items { margin-top: 12px; display: flex; flex-direction: column; gap: 10px; }
.detail-item { padding: 12px; border-radius: 10px; background: rgba(252, 250, 246, .82); display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.detail-item__meta { min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.detail-item__meta strong, .detail-item__right strong { color: var(--jf-color-text-primary); }
.detail-item__meta small { color: var(--jf-color-text-secondary); }
.detail-item__right { display: flex; align-items: center; gap: 12px; }
.detail-item__right button { border: 0; background: transparent; color: var(--jf-color-primary-dark); cursor: pointer; font: inherit; }
:deep(.option-code) { float: right; margin-left: 12px; color: var(--jf-color-text-secondary); font-size: 12px; }
@media (max-width: 1180px) {
  .detail-grid, .detail-actions { grid-template-columns: 1fr; }
}
</style>
